import "./index.scss";
import { Header, Banner } from "@google/glue";

import { AccordionComponent } from "./components/modules/accordion/accordion";
import { HeaderComponent } from "./components/header/header";
import { initOldCarousel } from "./components/modules/testimonials/testimonials";
import { NavigationComponent } from "./components/modules/navigation/navigation";
import {
  TextColumnImageTextGridComponent
} from "./components/modules/two-column-image-text-grid/two-column-image-text-grid";

// Lazy load Cookie Banner's CSS stylesheet in the <head>
const linkEl = document.createElement('link');
linkEl.setAttribute('rel', 'stylesheet');
linkEl.setAttribute(
  'href',
  'https://www.gstatic.com/glue/cookienotificationbar/cookienotificationbar.min.css'
);
document.head.appendChild(linkEl);


const headerElement = document.querySelector<HTMLElement>(".glue-header");
if (headerElement) {
  new Header(headerElement);
  new HeaderComponent(headerElement);
}

const bannerEl = document.querySelector<HTMLElement>('.glue-banner');
if (bannerEl) new Banner(bannerEl);

const navigationElement =
  document.querySelector<HTMLElement>(".glue-jumplinks");
if (navigationElement) new NavigationComponent();

const accordionElement = document.querySelector<HTMLElement>(".accordion");
if (accordionElement) new AccordionComponent();

const testimonialsElement =
  document.querySelectorAll<HTMLElement>(".testimonials");
if (testimonialsElement) initOldCarousel(testimonialsElement);

const textColumnImageTextGridElement = document.querySelector<HTMLElement>(
  ".two-column-image-text-grid"
);
if (textColumnImageTextGridElement) new TextColumnImageTextGridComponent();
